import { useMemo } from "react";
import GlobalService from "./GlobalService";

export default function useGlobalService() {
  return useMemo(() => new GlobalService(), []);
}
